module.exports = __webpack_public_path__ + "img/ar_news.9a8f9169.png";